import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import './styles/app.css'
import './styles/root.css'
import { queryClient } from './lib/query'
import { AuthProvider } from './state/AuthContext'
import { ToastProvider } from './components/ui/Toaster'
import { App } from './App'
import { Simulator } from './routes/Simulator'
import { DevMessaging } from './routes/DevMessaging'

// Three route trees in one SPA, resolved by pathname — no router dependency needed for this
// small a set of pages. /sim and /dev/messaging are standalone dev tools that don't need the
// agent shell (Rail/TopBar/UiProvider) at all.
function Root() {
  const path = window.location.pathname
  if (path.startsWith('/sim')) return <Simulator />
  if (path.startsWith('/dev/messaging')) return <DevMessaging />
  return (
    <AuthProvider>
      <App />
    </AuthProvider>
  )
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <ToastProvider>
        <Root />
      </ToastProvider>
    </QueryClientProvider>
  </StrictMode>,
)
